import React from 'react';
import { Link } from 'react-router-dom';
import { formatPhoneNumber } from 'shared/utils';
import { Title } from 'shared/components/abstract/interactables';
import DataTable from 'shared/components/table/DataTable';
import { searchSatelliteReceivers } from 'features/tenant/api/satellite';
import {
  TextEditor,
  withSelectorSwitch,
} from 'shared/components/data-display/editors';
import { dtvEntity, satellitePkgEntity } from 'shared/entityDetails';
import { withAsyncSelect } from 'shared/components/data-display/withSelectors';
import { getTenantReceiverPath } from 'shared/routes/tenant';
import { formatTenantName } from '../../shared/utils/formatters';
import { FILTER_DISPLAY_TYPE } from '../../shared/constants';

const filters = [
  {
    label: 'Packages',
    param: 'sat_pkg_id',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withAsyncSelect(satellitePkgEntity),
    entity: satellitePkgEntity,
  },
  {
    label: 'DirecTV',
    param: 'dtv_id',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withAsyncSelect(dtvEntity),
    entity: dtvEntity,
  },
  {
    label: 'PID',
    param: 'pid',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: TextEditor,
  },
  {
    label: 'Has Account Number?',
    param: 'has_account_number',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withSelectorSwitch(),
  },
];

const columns = [
  {
    name: 'Tenant',
    formatter: (row) => (
      <Link to={getTenantReceiverPath(row.tenant_id)}>{formatTenantName(row.tenant)}</Link>
    ),
    orderBy: 'it_firstname',
  },
  {
    name: 'Email',
    formatter: (row) => row.tenant.email,
  },
  {
    name: 'Phone',
    formatter: (row) => formatPhoneNumber(row.tenant.phone),
  },
  {
    name: 'Account #',
    jsonKey: 'account_number',
  },
  {
    name: 'RID',
    jsonKey: 'receiver_1_id',
  },
  {
    name: 'Receiver Model',
    jsonKey: 'receiver_1_model',
  },
  {
    name: 'Serial',
    jsonKey: 'receiver_1_serial',
  },
  {
    name: 'Card',
    jsonKey: 'receiver_1_card',
  },
];

export default function ReceiverSearch() {
  return (
    <>
      <Title title="Search Receivers" />
      <DataTable
        columns={columns}
        filters={filters}
        rowId="tenant_id"
        searchRequest={searchSatelliteReceivers}
        noRowsText=""
        className="table-height-large"
      />
    </>
  );
}
